import { forwardRef } from "react";
import PropTypes from "prop-types";

import MDButton from "components/MDButton";

/* Cancel button used in every dialog: the same gradient style as the primary
   (Save / Confirm) button beside it, in the theme's red gradient. */
const CancelButton = forwardRef(({ children, ...rest }, ref) => (
  <MDButton ref={ref} variant="gradient" color="error" {...rest}>
    {children}
  </MDButton>
));

CancelButton.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CancelButton;
